<template>
  <div class="org-card" v-if="payload" :data-id="payload['org-main-id']">
    <a :href="computedLink">

      <div class="org-card__header">
        <div v-if="payload['logo']" class="org-card__img-container">
          <img class="org-card__img" :src="payload['logo']" :alt="payload['org-name']">
        </div>

        <h3 v-if="payload['org-name']" class="org-card__title">
					{{ payload['org-name'] }}
					<div class="org-card__title-reviews" v-if="hasReviews">
						<img src="/images/icons/star.svg" class="org-card__title-reviews-icon"/>
						<p>{{ payload['reviews-score-latest'] }} ({{ payload['reviews-total'] }})</p>
					</div>
				</h3>

				<a :href="searchLink" v-if="hasListings" class="btn btn-blue-muted btn-small">Hiring</a>
      </div>

      <div class="org-card__body">
				<template v-if="payload['location-text']">
					<div class="org-card__location">
						<img src="/images/icons/organisation/location-new.png" class="org-card__location-icon"/>
						<p v-html="payload['location-text']"></p>
					</div>
				</template>

        <!-- description -->
        <p v-if="payload['summary']" class="org-card__summary" v-html="payload['summary']"></p>
      </div>

      <div class="org-card__footer">
        <block-alert-button class="org-card__btn--alert" :org_main_id="payload['org-main-id']" :org_name="payload['org-name']" title="Set up alert"></block-alert-button>
				<block-compare-button class="org-card__btn--compare" :org_slug="payload['slug']" title="Compare"></block-compare-button>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    payload: {
      type: [Object],
      default: {}
    }
  },

  data() {
    return {
			visible: false
    }
  },

	mounted() {
		// console.log('orgdata', this.payload);
		// this.payload['location-text'] = 'Testing';
		// this.payload['reviews-score-latest'] = 9.5;
		// this.payload['reviews-total'] = 50;
	},

	methods:{
		intersection_handler(entries, observer, isIntersecting, ratio) {
			//console.log("handle",entries, observer, isIntersecting, ratio);
			if (isIntersecting) {
				this.visible = true;
			}

		}
	},
  computed: {
		hasListings() {
			return (this.payload['listings-live-on-esc'] > 0 || this.payload['listings-live-on-other'] > 0)
		},
		searchLink() {
			var query_array = ["org-name="+this.payload['org-name']];
			var query = query_array.join("&");
			// Needs to be double encoded, don't know why!
			return '/search/jobs?q='+encodeURIComponent(encodeURIComponent(query));
		},
		computedLink() {
			if ('slug' in this.payload) {
				return `/organisation/${this.payload['slug']}`;
			}
			return '#';
		},
		hasReviews() {
			return (this.payload['reviews-score-latest'] !== null && this.payload['reviews-total'] !== null);
		}
  }
}
</script>
